import ContentsTypes from "@shared/enums/contentsTypes";
import customTypes from "@project/enums/contentsCustomTypes.enum";
const getDynamicAdminContentsTypes = ({ type }) => {
    switch (type) {
        case ContentsTypes.ROW:
        case ContentsTypes.COLUMN:
        case ContentsTypes.SECTION:
        case ContentsTypes.CONTAINER:
        case ContentsTypes.EXPANSION_PANEL_DETAILS:
        case ContentsTypes.DYNAMIC:
            return [
                customTypes.ARTICLE_SECTION,
                customTypes.GEOGRAPHIC_MAP,
                customTypes.BLOCK_WITH_TITLE,
                customTypes.TEXT_BLOCK_WITH_TITLE,
                customTypes.DESCRIPTION_TABS,
                customTypes.ILLUSTRATION_TABS,
                customTypes.DESCRIPTION_SERVICE_CARD,
                customTypes.DESCRIPTION_CARD_WITH_LOGO,
                customTypes.BLOCK_TITLE,
                customTypes.CONTACT_FORM,
                customTypes.MAILTO,
                customTypes.COLOR_IMAGE_BLOCK,
                customTypes.GRADIENT_BUTTON,
                customTypes.WITNESS_CARD,
                customTypes.PRODUCT_BLOCK,
                customTypes.CONTACT_BLOCK,
                customTypes.STEPS,
                customTypes.DESCRIPTION_SECTION,
                customTypes.SOLUTION_TYPE_ORGANISATION,
                customTypes.OFFERING_CARD,
                customTypes.OFFER_PRESENTATION_CARD,
                customTypes.INFOS_BLOCK,
                customTypes.LIST_WRAP,
                customTypes.COLUMNS_WITH_ICON,
            ];
        case ContentsTypes.GRID:
            return [
                customTypes.CARD_LABEL,
                customTypes.PRESENTATION_BOX,
                customTypes.DESCRIPTION_CARD_WITH_LOGO,
                customTypes.BLOCK_WITH_TITLE,
                customTypes.TEXT_BLOCK_WITH_TITLE,
                customTypes.ILLUSTRATION_TABS,
                customTypes.BLOCK_TITLE,
                customTypes.GRADIENT_BUTTON,
                customTypes.WITNESS_CARD,
                customTypes.COLOR_IMAGE_BLOCK,
                customTypes.CONTACT_FORM,
                customTypes.PRODUCT_BLOCK,
                customTypes.CONTACT_BLOCK,
                customTypes.DESCRIPTION_SECTION,
                customTypes.SOLUTION_TYPE_ORGANISATION,
                customTypes.OFFERING_CARD,
                customTypes.OFFER_PRESENTATION_CARD,
                customTypes.INFOS_BLOCK,
                customTypes.LIST_WRAP,
                customTypes.COLUMNS_WITH_ICON,
                customTypes.STAT_CARD,
            ];
        default:
            return [];
    }
};
export default getDynamicAdminContentsTypes;
